import { ColumnDef } from '@tanstack/react-table'
import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router-dom'
import { useStore } from '~/app/store'
import { Checkbox } from '~/shared/ui'
import type { PermissionAction, RolePermissionRow } from './model/types'

const PermissionCheckbox = observer((props: { actionName: string }) => {
  const { usersStore } = useStore()
  const location = useLocation()
  const isEditPage = location.pathname.includes('/edit')
  const action = isEditPage ? 'update' : 'add'

  const {
    saveSelectedpermissions,
    setSaveSelectedPermissions,
    setSelectedPermissions,
    selectedPermissions,
  } = usersStore
  const handleClick = () => {
    if (action === 'update') {
      setSelectedPermissions(props.actionName)
    } else {
      setSaveSelectedPermissions(props.actionName)
    }
  }
  return (
    <Checkbox
      onClick={() => handleClick()}
      checked={
        action === 'update'
          ? selectedPermissions.includes(props.actionName)
          : saveSelectedpermissions.includes(props.actionName)
      }
    />
  )
})

const createRoleColumns = (
  availablePermissions: PermissionAction[] = [],
): ColumnDef<RolePermissionRow>[] => {
  const columns: ColumnDef<RolePermissionRow>[] = [
    {
      header: 'name2',
      accessorKey: 'name2',
      cell: (row) => <p>{row.cell.row.original.name} </p>,
      maxSize: 10,
    },
  ]

  const actionTypes = ['create', 'update', 'delete', `get`]

  actionTypes.forEach((action) => {
    columns.push({
      header: action === 'get' ? 'get list' : action,
      accessorKey: action,
      cell: (row) => {
        const rowPerms = row.cell.row.original.permissions
        const hasAction = rowPerms.some(
          (perm: { originalName: string }) =>
            perm.originalName && perm.originalName.includes(action), // Проверяем, содержит ли `perm.name` текущий `action`
        )
        const findPerm = rowPerms.find((perm) =>
          perm.originalName.includes(action),
        )
        const actionName = findPerm?.originalName

        return hasAction ? (
          <div>
            <PermissionCheckbox actionName={actionName as string} />
          </div>
        ) : (
          <div className="w-[13px] border-t border-gray-500" />
        )
      },
      maxSize: 100,
    })
  })

  const namedPermissions = Array.from(
    new Map(
      availablePermissions
        .filter(
          (permission) =>
            !actionTypes.some((action) =>
              permission.originalName.includes(action),
            ),
        )
        .map((permission) => [permission.originalName, permission]),
    ).values(),
  )

  namedPermissions.forEach((permission) => {
    columns.push({
      id: permission.originalName,
      header: permission.displayName || permission.originalName,
      cell: (row) => {
        const actionName = row.cell.row.original.permissions.find(
          (rowPermission) =>
            rowPermission.originalName === permission.originalName,
        )?.originalName

        return actionName ? (
          <div>
            <PermissionCheckbox actionName={actionName} />
          </div>
        ) : (
          <div className="w-[13px] border-t border-gray-500" />
        )
      },
      maxSize: 160,
    })
  })

  return columns
}

export { createRoleColumns }
